<script lang="ts">
    import type { Snippet } from 'svelte';
    import type { Page } from '@shared/types/Tilelist.ts';

    type Props = { page: Page; visualRefreshActive: boolean; children: Snippet };

    const { children, page, visualRefreshActive }: Props = $props();

    const pageDataJson = $derived(JSON.stringify(page));
</script>

<!-- NOTE: Do not remove data-origin it is needed for the toggle in Everglades  -->
<div
    id="reptile-search-result"
    class={['reptile-search-result', { 'reptile-search-result--visual-refresh': visualRefreshActive }]}
    data-page={pageDataJson}
    data-qa="reptile-search-result"
    data-origin="dundee"
>
    {@render children()}
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-search-result {
        flex: 1 1 100%;
        max-width: 100%;

        /*                                                                                         */
        &--visual-refresh {
            background-color: tokens.$oc-semantic-color-background-canvas;
        }
    }
</style>
